module.exports = __webpack_public_path__ + "img/statische_website.3f0b6516.jpg";